import request from '@/utils/request'

/**
 *  个人咨询服务相关 API
 */

// 获取顾问基本信息
export function getConsultantBaseInfo(params) {
  return request({
    url: '/consultConsultant/consult/describe',
    method: 'get',
    params
  })
}

// 切换关注状态
export function toggleFollow(data) {
  return request({
    url: '/fans/followed',
    method: 'post',
    data
  })
}
// 取消关注
export function cancelFollow(data) {
  return request({
    url: '/fans/cancelFollowed',
    method: 'post',
    data
  })
}
// 切换收藏状态
export function toggleCollection(data) {
  return request({
    url: '/collection/add',
    method: 'post',
    data
  })
}
// 取消收藏
export function deleteCollection(data) {
  return request({
    url: '/collection/remove',
    method: 'post',
    data
  })
}

// 提交举报
export function submitReport(data) {
  return request({
    url: '/consultant/report',
    method: 'post',
    data
  })
}

// 提交评价
export function submitComment(data) {
  return request({
    url: '/consultant/comment',
    method: 'post',
    data
  })
}

// 管理擅长知识（添加/删除/移动）
export const manageKnowledge = params =>
  request({
    url: `/consultConsultant/consult/knowledge/${params.action}`,
    method: params.action === 'delete' ? 'delete' : 'post',
    data: JSON.stringify(params)
  })

// 更新状态（上线/休息/下线）
export const updateStatus = params =>
  request({
    url: '/consultConsultant/consult/status/update',
    method: 'post',
    data: JSON.stringify(params)
  })

// 调整价格
export const adjustPrice = params =>
  request({
    url: '/consultConsultant/consult/price/adjust',
    method: 'post',
    data: JSON.stringify(params)
  })

// 获取审核记录
export const getAuditRecords = params =>
  request({
    url: '/consultConsultant/consult/audit/records',
    method: 'get',
    params
  })

// 获取发布的知识列表
export const getPublishedKnowledge = params =>
  request({
    url: '/course/list',
    method: 'get',
    params
  })

// 获取订单统计数据
export const getOrderStats = params =>
  request({
    url: '/consultConsultant/consult/order/stats',
    method: 'get',
    params
  })

// 检查是否有未评价的预约单
export const checkUnratedAppointments = params =>
  request({
    url: '/consultConsultant/consult/appointment/unrated',
    method: 'get',
    params
  })

// 获取用户权限信息
export const getUserPermissions = params =>
  request({
    url: '/consultConsultant/consult/user/permissions',
    method: 'get',
    params
  })

// 保存推荐设置
export const saveRecommendSettings = params =>
  request({
    url: '/consultConsultant/consult/recommend/settings',
    method: 'post',
    data: JSON.stringify(params)
  })

// 检查修改信息权限
export const checkModifyPermission = params =>
  request({
    url: '/consultConsultant/consult/modify/check',
    method: 'get',
    params
  })

// 获取用户收藏数
export const getCollectionCount = params =>
  request({
    url: '/consultConsultant/consult/collect/count',
    method: 'get',
    params
  })

// 检查是否已关注
export const checkFollowStatus = params =>
  request({
    url: '/consultConsultant/consult/follow/check',
    method: 'get',
    params
  })

// 检查是否已收藏
export const checkCollectionStatus = params =>
  request({
    url: '/consultConsultant/consult/collect/check',
    method: 'get',
    params
  })

// 获取能力评级
export const getAbilityLevel = params =>
  request({
    url: '/consultConsultant/consult/ability/level',
    method: 'get',
    params
  })

// 获取代买权限状态
export const getBuyProxyPermission = params =>
  request({
    url: '/consultConsultant/consult/proxy/permission',
    method: 'get',
    params
  })

// 更新顾问状态（新版本）
export function updateConsultantStatus(data) {
  return request({
    url: `/consultConsultant/consult/online`,
    method: 'post',
    data
  })
}
// 下线顾问
export function offlineConsultant(data) {
  return request({
    url: `/consultConsultant/consult/offline`,
    method: 'post',
    data
  })
}
// 检查顾问信息完整性
export function checkConsultantInfo(consultantId) {
  return request({
    url: `/consultant/checkInfo`,
    method: 'get',
    params: {consultantId}
  })
}
// 咨询开启
export function openConsultant(data) {
  return request({
    url: `/consultConsultant/consult/enable`,
    method: 'post',
    data
  })
}
// 咨询状态休息
export function restConsultant(data) {
  return request({
    url: `/consultConsultant/consult/rest`,
    method: 'post',
    data
  })
}

// 获取推荐设置
export function getRecommendSettings(consultantId) {
  return request({
    url: `/consultant/recommendSettings`,
    method: 'get',
    params: {consultantId}
  })
}

// 更新推荐设置
export function updateRecommendSettings(data) {
  return request({
    url: `/consultant/updateRecommendSettings`,
    method: 'post',
    data
  })
}

// 获取职业列表
export function getOccupationList() {
  return request({
    url: `/common/occupationList`,
    method: 'get'
  })
}

// 获取区域列表
export function getAreaList() {
  return request({
    url: `/area/list`,
    method: 'get'
  })
}

// 获取知识列表
export function getKnowledgeList(consultantId) {
  return request({
    url: '/consultConsultant/knowledge/list',
    method: 'get',
    params: {consultantId}
  })
}

// 新增知识
export function addKnowledge(data) {
  return request({
    url: '/consultConsultant/knowledge/create',
    method: 'post',
    data
  })
}

// 删除知识
export function deleteKnowledge(data) {
  return request({
    url: '/consultConsultant/knowledge/delete',
    method: 'post',
    data
  })
}

// 更新知识排序
export function updateKnowledgeOrder(data) {
  return request({
    url: '/consultConsultant/knowledge/order',
    method: 'post',
    data
  })
}

// 获取评价记录
export function getEvaluationRecords(params) {
  return request({
    url: '/evaluation/consultAppointment/records',
    method: 'get',
    params
  })
}

// 提交评价
export function submitEvaluation(data) {
  return request({
    url: '/evaluation/consultAppointment',
    method: 'post',
    data
  })
}

// 删除评价
export function deleteEvaluation(data) {
  return request({
    url: '/evaluation/consultAppointment/removeRecords',
    method: 'post',
    data
  })
}

// 获取未评价预约单
export function getUnratedAppointments(params) {
  return request({
    url: '/evaluation/consultAppointment/ids',
    method: 'get',
    params
  })
}

// 获取我的粉丝列表
export function getFansList(params) {
  return request({
    url: '/fans/list',
    method: 'get',
    params
  })
}

// 移除粉丝
export function removeFans(data) {
  return request({
    url: '/fans/removeFans',
    method: 'post',
    data
  })
}

// 设置平台推荐级别
export function setPlatformRecommend(data) {
  return request({
    url: '/consultConsultant/consult/platformRecommend',
    method: 'post',
    data
  })
}

// 获取修改信息详情
export function getModifyInfoDetail(params) {
  return request({
    url: '/consultConsultant/consult/update/info',
    method: 'get',
    params
  })
}

// 提交修改信息申请
export function submitModifyInfo(data) {
  return request({
    url: '/consultConsultant/consult/update',
    method: 'post',
    data
  })
}

// 申请修改信息（需要审核）
export function submitModifyApplication(data) {
  return request({
    url: '/consultConsultant/consult/update/application',
    method: 'post',
    data
  })
}

// 获取职业列表
export function getEmployeeOccupationList() {
  return request({
    url: '/employeeOccupation/list',
    method: 'get'
  })
}

// 获取知名公司短名称列表
export function getFamousInternetCompanyShortNameList() {
  return request({
    url: '/famousInternetCompany/shortNameList',
    method: 'get'
  })
}

// 获取价格设置详情
export function getPriceSetting(params) {
  return request({
    url: '/consultConsultant/consult/queryPriceSetting',
    method: 'get',
    params
  })
}

// 设置价格
export function setPriceSetting(data) {
  return request({
    url: '/consultConsultant/consult/setPriceSetting',
    method: 'post',
    data
  })
}

// 获取审核记录列表
export function getAuditRecordList(params) {
  return request({
    url: '/consultConsultant/application/list',
    method: 'get',
    params
  })
}

// 申请评定
export function submitAbilityAssessmentApplication(data) {
  return request({
    url: '/consultConsultant/consult/abilityAssessmentApplication',
    method: 'post',
    data
  })
}
